import httpClient from "../../../shared/api/httpClient";

export const termsApi = {
  // `version` é a versão que o usuário leu (current_terms_version de GET /me): o backend
  // recusa com 422 se os termos tiverem mudado nesse meio-tempo.
  accept: (version) =>
    httpClient.post("/api/v1/me/terms-acceptance", { version }).then((r) => r.data.dados),
};
